import { backToTopLauncher } from '../../exports/backToTopLauncher';

export function loadWidgetButtons(isTextToTopEnabled) {
    // Pin Back to Top button to bottom, since we don't show chat widget
    backToTopLauncher({ isCopyEnabled: isTextToTopEnabled, showChatWidget: false });
}
